// Modal Backdrop
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  [data-theme='dark'] & {
    background: rgba(0, 0, 0, 0.7);
  }
}

// Modal Container
.modal {
  width: 100%;
  max-width: 440px;
  background: var(--color-surface-primary);
  border-radius: map.get($radius, 'lg');
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

// Header
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'xl');
  border-bottom: 1px solid var(--color-grey-soft);
}

.title {
  @include heading-4;
  margin: 0;
  color: var(--color-text-primary);
}

.closeButton {
  flex-shrink: 0;
}

// Content
.content {
  padding: map.get($spacing-scale, 'xl');
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'md');
}

.message {
  @include body-regular;
  color: var(--color-text-primary);
  margin: 0;
}

// Inline error message (shown below the confirmation text)
.error {
  @include metadata-regular;
  color: var(--color-semantic-danger);
  margin: 0;
}

// Footer
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'md') map.get($spacing-scale, 'xl');
  border-top: 1px solid var(--color-grey-soft);
}

// Responsive adjustments
@media (max-width: $breakpoint-md) {
  .modal {
    max-width: 100%;
    border-radius: map.get($radius, 'md');
  }

  .header {
    padding: map.get($spacing-scale, 'md');
  }

  .content {
    padding: map.get($spacing-scale, 'md');
  }

  .footer {
    padding: map.get($spacing-scale, 'md');
  }
}
